module.exports = __webpack_public_path__ + "media/images/apple-touch-icon-17564c2edf80be24700b10dafe906809.png";